import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import squiggle from '../assets/graphics/squiggle.svg';

class Squiggle extends Component {

    // This component seems to completely re-render on any change of the welcome-page.
    // which prevents transition of colour.
    shouldComponentUpdate() {
        const { surpressUpdate } = this.props;
        return !surpressUpdate;
    }

    render() {
        const { className, size, style } = this.props;

        return(
            <ReactSVG src={ squiggle } className={ className } svgStyle={ style } />
        );
    }
}



export default Squiggle;


// WEBPACK FOOTER //
// ./src/components/squiggle.js